import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/specification"
const defaultSpecificationsLimit = 1000

export const addSpecification = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const getSpecifications = async (queries) => {
  const normalizedQueries = {
    limit: defaultSpecificationsLimit,
    ...(queries || {})
  }

  const query =
    stringify(normalizedQueries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const getSpecification = async (specificationId) => {
  const response = await farasod.get(`${endpoint}/${specificationId}`)

  return response.data
}

export const editSpecification = async (specificationId, data) => {
  const response = await farasod.patch(`${endpoint}/${specificationId}`, data)

  return response.data
}

export const deleteSpecification = async specificationId => {
  const response = await farasod.delete(`${endpoint}/${specificationId}`)

  return response.data
}

export const addSpecificationItem = async (specificationId, data) => {
  const response = await farasod.post(`${endpoint}/${specificationId}/specificationItem`, data)

  return response.data
}

export const editSpecificationItem = async (specificationId, specificationItemId, data) => {
  const response = await farasod.patch(`${endpoint}/${specificationId}/specificationItem/${specificationItemId}`, data)

  return response.data
}

export const deleteSpecificationItem = async (specificationId, specificationItemId) => {
  const response = await farasod.delete(`${endpoint}/${specificationId}/specificationItem/${specificationItemId}`)

  return response.data
}
